import React from "react";
import B2BNav from "../Landing/B2BNav";
import B2BFooter from "../Landing/B2BFooter";
import "../Landing/b2b.css";

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <B2BNav />
      <div className="legal-content">
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p className="legal-updated">Effective Date: January 2025</p>
        </div>
        <div className="legal-body">
          <section>
            <h2>1. Service Agreement</h2>
            <p>
              These terms govern the lead generation services provided by The Local Intent Company ("Company", "we", "us")
              to affiliates and users ("Users", "you"). By using our platform, you agree to these terms.
            </p>
          </section>

          <section>
            <h2>2. Services Provided</h2>
            <p>The Local Intent Company provides:</p>
            <ul>
              <li>Automated social media monitoring for lead opportunities</li>
              <li>AI-powered response generation and posting</li>
              <li>Account management and connection services</li>
              <li>Campaign tracking and analytics dashboard</li>
              <li>Account marketplace for verified social accounts</li>
            </ul>
          </section>

          <section>
            <h2>3. User Obligations</h2>
            <p>Users agree to:</p>
            <ul>
              <li>Provide accurate account and payment information</li>
              <li>Use the service in compliance with applicable laws</li>
              <li>Not engage in spam, harassment, or deceptive practices</li>
              <li>Maintain the security of connected accounts</li>
              <li>Pay fees according to the pricing terms</li>
            </ul>
          </section>

          <section>
            <h2>4. Fees and Payment</h2>
            <p>
              Platform fees are $10 per month per connected account. Account purchases from the marketplace
              are one-time fees that vary by location. All payments are processed securely.
              Subscriptions renew automatically unless cancelled.
            </p>
          </section>

          <section>
            <h2>5. Account Replacement Guarantee</h2>
            <p>
              We provide free replacement for accounts that are banned or suspended while following our
              platform guidelines. This guarantee does not cover accounts banned due to user misuse
              or violation of platform terms.
            </p>
          </section>

          <section>
            <h2>6. Intellectual Property</h2>
            <p>
              All platform technology, AI systems, and branding remain the property of The Local Intent Company.
              Users retain ownership of their connected accounts and generated leads.
            </p>
          </section>

          <section>
            <h2>7. Limitation of Liability</h2>
            <p>
              The Company is not liable for lost revenue, account actions by third-party platforms,
              or indirect damages. Our liability is limited to fees paid in the preceding 3 months.
            </p>
          </section>

          <section>
            <h2>8. Termination</h2>
            <p>
              Users may cancel their subscription at any time. The Company reserves the right to suspend
              or terminate accounts for violations of these terms or abuse of the platform.
            </p>
          </section>

          <section>
            <h2>9. Governing Law</h2>
            <p>
              These terms are governed by the laws of the State of Delaware, United States.
              Any disputes will be resolved through binding arbitration.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>
              For questions about these terms, contact us at: {" "}
              <a href="mailto:support@thelocalintent.company">support@thelocalintent.company</a>
            </p>
          </section>
        </div>
      </div>
      <B2BFooter />
    </div>
  );
};

export default TermsOfService;
